import { styled } from "@mui/system";
import Box from "@mui/material/Box";
export default styled(Box)(({ theme }) => ({
    "&.auth-wrapper-agency": {
        minHeight: "100vh",
        paddingBottom: 50,
        paddingTop: 50,
        background: "#808080",
        ".auth-wrapper_uhf": {
            ".sign-in , .reset-password ": {
                backgroundColor: '#fb6647'
            },
            ".sign-in-text": {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
            }
        },
        ".auth-wrapper": {
            "input, button, .MuiInputBase-root.MuiOutlinedInput-root": {
                borderRadius: "5px !important",
                fontSize: 14,
                fontWeight: 300,
            },
            ".MuiInputBase-root.MuiOutlinedInput-root": {
                maxHeight: 36,
                color: "black",
                background: "#fff",
            },
            input: {
                [theme.breakpoints.down(425)]: {
                    width: "100%"
                }
            },
            width: 396,
            background: "#eae8db",
            margin: "0px auto",
            "#logo-icon-header": {
                background: "white",
                paddingBottom: 20,
            },
            "button[type='submit']": {
                width: "100%",
                padding: 5,
                fontSize: "14px !important",
                textTransform: "capitalize",
                marginBottom: 15,
            },
            ".forgot-password_go-to-sign": {
                padding: 0
            },
            [theme.breakpoints.down(560)]: {
                width: "auto",
                marginRight: 20,
                marginLeft: 20,
                overflow: "hidden",
                "#logo-icon-header img": {
                    width: "90%"
                }
            },
        },
    },
}));
